import React, { forwardRef } from "react";
import "./Styles.css";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/logo23.png";
import { FaYoutube, FaInstagram, FaLinkedinIn, FaReddit } from "react-icons/fa";
import { SiX, SiMedium } from "react-icons/si"; // X logo

const Footer = forwardRef(({ sectionsRef }, ref) => {
  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <footer ref={ref} className="site-footer text-light py-5">
      <hr className="border-secondary mt-4" />

      <Container>
        <Row>
          <Col md={5} className="mb-4 mb-md-0">
            <div className="d-flex align-items-center mb-3">
              <img src={logo} alt="guftagu" className="footer-logo me-2" />
              <h5 className="fw-bold mb-0">gupsy</h5>
            </div>
            <div className="d-flex gap-3 mt-3">
              <a href="https://www.youtube.com/@GuftaguAIcompanion" target="_blank" rel="noopener noreferrer" className="social-icon"><FaYoutube /></a>
              <a href="https://x.com/GuftaguAI" target="_blank" rel="noopener noreferrer" className="social-icon"><SiX /></a>
              <a href="https://www.instagram.com/guftaguaiofficial/" target="_blank" rel="noopener noreferrer" className="social-icon"><FaInstagram /></a>
              <a href="https://www.reddit.com/user/Guftaguai/" target="_blank" rel="noopener noreferrer" className="social-icon"><FaReddit /></a>
              <a href="https://medium.com/@mark.guftagu" target="_blank" rel="noopener noreferrer" className="social-icon"><SiMedium /></a>
            </div>
          </Col>

          <Col md={3} sm={3} className="mb-4 mb-md-0">
            <ul className="list-unstyled footer-links">
              <li><Link onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Home</Link></li>
              <li><Link onClick={() => scrollToSection(sectionsRef.about)}>About Us</Link></li>
              <li><Link to="/reach-us">Reach Us</Link></li>
            </ul>
          </Col>

          <Col md={3} sm={3} className="mb-4 mb-md-0">
            <ul className="list-unstyled footer-links">
              <li><Link onClick={() => scrollToSection(sectionsRef.getInTouch)}>Use Cases</Link></li>
              <li><Link onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Pre - Register</Link></li>
              <li><Link onClick={() => scrollToSection(sectionsRef.memory)}>How it works?</Link></li>
            </ul>
          </Col>

          {/* <Col md={2} sm={3} className="mb-4 mb-md-0">
            <ul className="list-unstyled footer-links">
            </ul>
          </Col> */}
        </Row>
      </Container>

      <hr className="border-secondary mt-4" />
      <div className="text-center">© {new Date().getFullYear()} Neomonks Tech Pvt Ltd. All rights reserved.</div>
    </footer>
  );
});

export default Footer;